import { FilterLimitPresets } from '@/models/filter/filterDefaultLimits';
import { isNonEmptyStringArray } from '@/models/filter/utils/isNonEmptyStringArray';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter/filterConfig';

import { buildSubnationalSalesOptionsQuery, SUBNATIONAL_SALES_CUBE_NAME } from './subnationalSalesOptionsQuery';

const DIMENSION = `${SUBNATIONAL_SALES_CUBE_NAME}.sales_distribution_channel_name`;

const salesPrescriptionTypeFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.salesPrescriptionTypeLabel',
  placeholder: 'global.filters.formControls.salesPrescriptionTypeLabel',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  sourceCube: SUBNATIONAL_SALES_CUBE_NAME,
  getOptionsQuery: buildSubnationalSalesOptionsQuery(DIMENSION, FilterLimitPresets.LIMIT_100),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    if (!isNonEmptyStringArray(value)) return undefined;
    return { member: DIMENSION, operator: 'equals', values: value };
  },
};

export default salesPrescriptionTypeFilter;
